<template>
    <Login />
</template>

<script>
    export default {
        name: 'login',
        components: {
            'Login': () => import("../components/Login")
        },
    }
</script>

<style scoped>

</style>
